export type PartialMessageProps = {
  text: string;
  isBold?: boolean;
  url?: string;
};

const PartialMessage = ({
  text = '',
  url = '',
  isBold = false,
}: Partial<PartialMessageProps> = {}): PartialMessageProps => ({
  text: String(text),
  url: String(url),
  isBold: Boolean(isBold),
});

export default PartialMessage;
